<div class="container">
    <form [formGroup]="signatureFormGroup" (ngSubmit)="onSignatureFormSubmit()">
    <mat-radio-group
            class="signature-radio-group"
            (change)="signatureTypeChoiceChange($event)">
        <mat-radio-button [value]="SIGNATURETYPE_RADIO_WITHFULLNAME">
            <span class="matRadioButtonLabel">{{'SIGNATURE.withFullNameSignature' | translate}}</span>
        </mat-radio-button>
        <div #radioWithFullNameSignatureDiv style="display:none;width:100%">
            <div><div class="labelFullName">{{'SIGNATURE.fullName'|translate}}</div>
                 <input #fullNameAloneInput class="inputFullName" matInput [formControlName]="'fullNameAlone'" type="text" readonly />
            </div>
         </div>
        <mat-radio-button [value]="SIGNATURETYPE_RADIO_HANDWRITTEN">
            <span class="matRadioButtonLabel"> {{'SIGNATURE.handwrittenSignature' | translate}}</span>
        </mat-radio-button>
        <div #radioHandwrittenSignatureDiv style="display:none;width:100%">
            <div><div class="labelFullName">{{'SIGNATURE.fullName'| translate}}</div>
                <input #fullNameForHandwrittenInput class="inputFullName" matInput type="text"  [formControlName]="'fullNameForHandwritten'" readonly />
            </div>
            <div class="canvasContainer">
                <div #signatureMatIconContainer class="signature-mat-icon-container">
                    <mat-icon [ngClass]="signaturePadIsEmpty()?'signature-mat-icon-delete-hide':''" fontSet="material-icons-outlined" class="signature-mat-icon-delete" (click)="signatureClear()">delete</mat-icon>
                    <!--
                    <mat-icon [ngClass]="signaturePadIsEmptyOrMinSize()?'signature-mat-icon-compress-hide':''" fontSet="material-icons-outlined" class="signature-mat-icon-compress" (click)="resizeSignatureCompress()">compress</mat-icon>
                    <mat-icon [ngClass]="signaturePadIsEmptyOrMaxSize()?'signature-mat-icon-expand-hide':''" fontSet="material-icons-outlined" class="signature-mat-icon-expand" (click)="resizeSignatureExpand()">expand</mat-icon>
                    -->
                </div>
                <canvas #signaturePadCanvas class="signature-pad-canvas" ></canvas>
            </div>
            <div *ngIf="AUTO_RESIZE" class="autoResizeInfo">
                {{ 'SIGNATURE.autoResize' | translate}} : <span class="defaultAutoSizeChange" (click)="displayAutoSizeChangeCombo()" *ngIf="TO_SEND_WIDTH">{{TO_SEND_WIDTH}} px X {{TO_SEND_HEIGHT}} px</span><span *ngIf="displayAutoSizeChange"><select (change)="autoSizeChange($event)" class="autoSizeChangeSelect"><option value="{{TO_SEND_WIDTH_SMALL}}">{{TO_SEND_WIDTH_SMALL}} px X {{TO_SEND_WIDTH_SMALL/2}} px</option><option selected value="{{TO_SEND_WIDTH_DEFAULT}}">{{TO_SEND_WIDTH_DEFAULT}} px X {{TO_SEND_WIDTH_DEFAULT/2}} px</option><option value="{{TO_SEND_WIDTH_BIG}}" >{{TO_SEND_WIDTH_BIG}} px X {{TO_SEND_WIDTH_BIG/2}} px</option></select></span>
            </div>
            <div #appUploadFileDiv>
                <app-upload-file (uploadFile)="handleFileUpload($event)" [uploadFileConfig]="uploadFileConfig"></app-upload-file>
            </div>
            <div *ngIf="invalidFormat" class="invalidFormat"><mat-icon class="errorIcon">error</mat-icon>{{'SIGNATURE.invalidFormat'|translate}}</div>
            <label class="checkbox-container" appTooltip="{{'SIGNATURE.saveSignatureToolTip' | translate}}">
                <input type="checkbox"
                       [formControlName]="'saveHandwrittenSignature'" >
                <span class="checkbox">
                    <span class="checkbox-mark"></span>
                </span>
                <span  class="labelSaveSignature">{{'SIGNATURE.saveSignature' | translate}}</span>
                <br><br><br><br>
            </label>
        </div>
    </mat-radio-group>
    <div class="buttonContainer">
        <button
                type="button"
                *ngIf="this.signatureType === SIGNATURETYPE_RADIO_HANDWRITTEN"
                class="secondaryButton"
                [ngClass]="signaturePadIsEmpty()?'exportButtonDisable':''"
                (click)="downloadSignatureImage()"
                appTooltip="{{'SIGNATURE.exportTooltip' | translate}}"
                [display]="!signaturePadIsEmpty()"
        >{{'SIGNATURE.export' | translate}} <mat-icon  class="matDownload">file_download</mat-icon></button>

        <button
                *ngIf="this.signatureType === SIGNATURETYPE_RADIO_WITHFULLNAME || this.signatureType === SIGNATURETYPE_RADIO_HANDWRITTEN"
                class="primaryButton"
                type="submit"
                [disabled]="signed"
        >{{'SIGNATURE.sign' | translate}}<mat-icon fontSet="material-icons-outlined" class="matIconCheck">check_small</mat-icon></button>

    </div>
    </form>
</div>
